<template>
  <button type="button" class="btn btn-light" @click="show = true">Add VIP Services</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add VIP Services</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="existing-flight mb-3">
            <label for="">Add VIP Services</label>
            <select class="form-select" v-model="order_vip.services">
              <option :value="null"></option>
              <option v-for="(product, index) in products" :key="index" :value="product">
                {{ product.name }}
              </option>
            </select>
          </div>
          <div class="flight-data">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="">Quantity</label>
                  <input type="number" class="form-control" v-model="order_vip.qty">
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="">Price</label>
                  <div class="input-group">
                    <span class="input-group-text" id="basic-addon1">$</span>
                    <input type="number" class="form-control" v-model="order_vip.price">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="addToOrder()">Add to order</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
export default {
  name: 'TaxModal',
  props: ['form', 'products'],
  data() {
    return {
      show: false,
      order_vip: {
        services: null,
        qty: null,
        price: null,
      },
    }
  },
  methods: {
    addToOrder() {
      let services = this.order_vip.services
      let qty = this.order_vip.qty
      let price = this.order_vip.price

      this.form.order_lines.push({
        type: 'vip',
        name: services.name,
        price: price,
        qty: qty,
      })

      this.show = false;

      this.order_vip.services = null;
      this.order_vip.qty = null;
      this.order_vip.price = null;
    }
  }
}
</script>

<style>

</style>
